module.exports = __webpack_public_path__ + "assets/img/swiper-img2-53a07768.png";